export default __webpack_public_path__ + "img/toggle-off.31c675cf.svg";